(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discover-teas"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll('.discover-teas-outer').forEach(function (root) {
      var el = root.querySelector('.teas-slider.swiper');
      if (!el || el.classList.contains('swiper-initialized')) return;
      var slideCount = el.querySelectorAll('.swiper-slide').length;
      new Swiper(el, {
        loop: slideCount > 2,
        navigation: {
          prevEl: root.querySelector('.custom-slider-arrows .prev-arrow'),
          nextEl: root.querySelector('.custom-slider-arrows .next-arrow')
        },
        breakpoints: {
          0: { slidesPerView: 1, spaceBetween: 10 },
          769: { slidesPerView: 2, spaceBetween: 50 }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-imgtxt-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll('.holiday-imgtxt-main').forEach(function (root) {
      var el = root.querySelector('.holiday-imgtxt-swiper');
      if (!el || el.classList.contains('swiper-initialized')) return;
      var slideCount = el.querySelectorAll('.swiper-slide').length;
      new Swiper(el, {
        loop: slideCount > 1,
        autoHeight: true,
        slidesPerView: 1,
        navigation: {
          prevEl: root.querySelector('.holiday-prev-arrow'),
          nextEl: root.querySelector('.holiday-next-arrow')
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[grid-recommendation]').innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tea-tour-gallery"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  var itemsToShow = 4; // how many to show each click
  var $items = $('.gallery-item');
  var $button = $('.load-more');

  $button.on('click', function(){
    var hiddenItems = $items.filter('.hidden').slice(0, itemsToShow);
    
    hiddenItems.each(function(i, el){
      setTimeout(function(){
        $(el).removeClass('hidden').addClass('fade-in');
      }, i * 150); // staggered animation
    });

    // hide button if no more hidden items
    if($items.filter('.hidden').length === 0){
      $button.hide();
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
